import { render, staticRenderFns } from "./PaymentCancel.vue?vue&type=template&id=18194397&"
import script from "./PaymentCancel.vue?vue&type=script&lang=js&"
export * from "./PaymentCancel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentCancel.vue"
export default component.exports